import { useRef, useState } from 'react';
import { NavLink } from 'react-router';
import { useAuth } from '../../context/AuthContext.js';
import { Avatar } from './Avatar.js';
import { Button } from './Button.js';
import { Select } from './FormField.js';
import { Popover } from './Popover.js';
import { ThemeModeSwitch } from './ThemeModeSwitch.js';

export function UserMenu() {
  const { user, logout, memberships, activeSupplierId, switchSupplier } = useAuth();
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  if (!user) return null;

  const fullName = `${user.first_name} ${user.last_name}`.trim();
  const showSwitcher = (memberships ?? []).length > 1;

  return (
    <div className="mt-auto flex flex-col gap-3 border-t border-hairline-soft p-3">
      {showSwitcher && (
        <label className="block" htmlFor="active-supplier-select">
          <span className="mb-1 block text-xs font-medium text-steel">Active supplier</span>
          <Select
            id="active-supplier-select"
            value={activeSupplierId ?? ''}
            onChange={(e) => {
              void switchSupplier(e.target.value);
            }}
            className="w-full"
          >
            {memberships.map((m) => (
              <option key={m.supplier_id} value={m.supplier_id}>
                {m.supplier_name ?? m.supplier_id}
              </option>
            ))}
          </Select>
        </label>
      )}
      <button
        ref={triggerRef}
        type="button"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-surface"
      >
        <Avatar name={fullName || user.email} src={user.avatar_url ?? undefined} size="sm" />
        <span className="min-w-0 flex-1 text-left">
          <span className="block truncate text-sm font-medium text-ink">
            {fullName || user.email}
          </span>
          <span className="block truncate text-xs text-steel">{user.email}</span>
        </span>
      </button>
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorRef={triggerRef}
        label="Account menu"
      >
        <div className="flex w-56 flex-col gap-3 p-3">
          <NavLink
            to="/profile"
            onClick={() => setOpen(false)}
            className="rounded-md px-2 py-1.5 text-sm text-ink hover:bg-surface"
          >
            View profile
          </NavLink>
          <ThemeModeSwitch />
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start"
            onClick={() => {
              setOpen(false);
              logout();
            }}
          >
            Sign out
          </Button>
        </div>
      </Popover>
    </div>
  );
}
